"use client";

export { LoginLayoutError as default } from "../../../ui/layouts/login-layout/login-layout-error";
